export default __webpack_public_path__ + "static/media/imgkahshpay_2.71325c3f.png";